export default {
  errors: {
    downloadPdfFailed: 'Nepodarilo sa stiahnuť správu o kvalite pre {report}. Ak sa chyba opakuje, kontaktujte technickú podporu Qmulus.',
    contentUrlNotSet: 'Nepodarilo sa určiť URL adresu PDF pre správu {report}.',
  },
  longRunning: {
    summary: 'Generovanie správy',
    detail: 'Generovanie správy môže chvíľu trvať. Prosím, nechajte okno prehliadača otvorené. Táto správa sa zavrie po dokončení požiadavky',
  },
};
